export default "__VITE_ASSET__bsQX6tP7__"